import { render, staticRenderFns } from "./ShareDistribution.vue?vue&type=template&id=60257fcb&"
import script from "./ShareDistribution.vue?vue&type=script&lang=ts&"
export * from "./ShareDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports